module.exports = __webpack_public_path__ + "static/media/ipa.53aae22b.png";